import { render } from "./TaskDetails.vue?vue&type=template&id=fdaeaf0a"
import script from "./TaskDetails.vue?vue&type=script&lang=js"
export * from "./TaskDetails.vue?vue&type=script&lang=js"

import "./TaskDetails.vue?vue&type=style&index=0&id=fdaeaf0a&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__